module.exports = __webpack_public_path__ + "img/maps-and-location-2.507cc166.svg";